import { GlobalAdapter } from "@core/store/adapters/global.adapter";
import { Action, createFeatureSelector, createReducer, createSelector, on } from "@ngrx/store";

import { GlobalState } from "@core/entities/global.interface";
import * as GlobalAction from "@core/store/actions/global.action";
import { Mutator } from "@core/utils";

const initialState: GlobalState = {
  comms: {
    header: null,
    announcements: [],
    notifications: [],
  },
  pickup_points: null,
  dragCoords: null,
  checkin: null,
  ui: {
    loadPickingPoints: false,
    loadingCheckin: false,
    failedCheckin: false,
    loadingRetailer: false,
    loadingReport: false,
    visibleHeader: false,
  },
};

const globalReducerCreate = createReducer(
  initialState,
  on(GlobalAction.clearAll, () => initialState),
  on(GlobalAction.setComms, (state, { payload }) => ({ ...state, comms: payload })),
  on(GlobalAction.uiGlobal, (state, { ui }) => GlobalAdapter.setUi(ui, state)),
  on(GlobalAction.setPickupPoints, (state, { payload }) => ({ ...state, pickup_points: payload })),
  on(GlobalAction.setDragCoords, (state, { payload }) => ({ ...state, dragCoords: payload })),
  on(GlobalAction.setCheckin, (state, { checkin }) => ({ ...state, checkin: Mutator.copy(checkin) })),
  on(GlobalAction.setRetailers, (state, { retailers }) => ({ ...state, retailers }))
);

export function GlobalReducer(state: GlobalState, action: Action) {
  return globalReducerCreate(state, action);
}

export const getGlobal = createFeatureSelector<GlobalState>("global");
export const getComms = createSelector(getGlobal, ({ comms }) => comms);
export const getUiGlobal = createSelector(getGlobal, ({ ui }) => ui);
export const getPickupPoints = createSelector(getGlobal, ({ pickup_points }) => pickup_points);
export const getDragCoords = createSelector(getGlobal, ({ dragCoords }) => dragCoords);
export const getCheckin = createSelector(getGlobal, ({ checkin }) => checkin);
